export function calculateOffset(timestamp: number, epgParams: any, width?: number, duration?: number): number {
  const { channelWidth, epgStartTimestamp, epgStartEndDifference, epgWidth } = epgParams;

  if (duration && width) {
    const programRatio = width / duration;
    return (timestamp - epgStartTimestamp + channelWidth / 2) * programRatio;
  }
  return ((timestamp - epgStartTimestamp + channelWidth) / (epgStartEndDifference + channelWidth)) * epgWidth;
}
